module.exports = __webpack_public_path__ + "img/webImg.cace01dd.png";